import { TButtonType, TLink } from "../../../types";
import styles from "./hero-text-button-area.module.less";
import Heading from "../heading/heading";
import { PrimaryButtonLink, SecondaryButtonLink } from "../button/button";
import { isOrHandleAsExternalUrl } from "../../../helpers";
import { THeadingTypes } from "../../../types/heading-types";
import animations from "../../../animation/animation.module.less";
import { useIntersectionObserver } from "usehooks-ts";

export type THeroTextButtonAreaProps = {
  eyebrow?: string;
  heading?: string;
  visualHeadingType?: Exclude<THeadingTypes, "h6">;
  text?: string;
  buttonLink?: TLink;
  buttonType?: TButtonType;
  index: number | undefined;
};

const HeroTextButtonArea = ({
  eyebrow,
  heading,
  text,
  buttonLink,
  visualHeadingType = "h1",
  buttonType = "primary",
  index,
}: THeroTextButtonAreaProps) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.25,
    freezeOnceVisible: true,
  });

  const animationClassesText = [
    index === 0 ? animations.fadeInDelay100 : isIntersecting ? animations.fadeInDelay100 : "",
    animations.opacity0,
  ].join(" ");

  const animationClassesButtonWrapper = [
    index === 0 ? animations.fadeInToTopDelay200 : isIntersecting ? animations.fadeInToTopDelay200 : "",
    animations.opacity0,
  ].join(" ");

  return (
    <div ref={ref} className={"heading-max-width"}>
      <div className={animationClassesText}>
        {eyebrow && <p className={`eyebrow ` + styles.eyebrow}>{eyebrow}</p>}
        {heading && (
          <Heading index={index} visualType={visualHeadingType} semanticType={"h2"} className={styles.heading}>
            {heading}
          </Heading>
        )}
        {text && <p className={["text-max-width", styles.text].join(" ")}>{text}</p>}
      </div>
      {buttonLink && (
        <div className={[styles.buttonWrapper, animationClassesButtonWrapper].join(" ")}>
          {buttonType === "primary" ? (
            <PrimaryButtonLink
              url={buttonLink.url}
              label={buttonLink.title}
              iconRight={buttonLink.icon ?? "ui-icon-arrow-right"}
              openInNewTab={isOrHandleAsExternalUrl(buttonLink.url, buttonLink?.target)}
            />
          ) : (
            <SecondaryButtonLink
              url={buttonLink.url}
              label={buttonLink.title}
              iconRight={buttonLink.icon ?? "ui-icon-arrow-right"}
              openInNewTab={isOrHandleAsExternalUrl(buttonLink.url, buttonLink?.target)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default HeroTextButtonArea;
